export enum ServiceIntervalState
{
    NotDone = 0,
    MarkedDoneByUser = 1,
    MarkedDoneFromDms = 2
}